import * as React from 'react';
import { CheckCircleOutlined, MinusCircleOutlined, SyncOutlined } from '@ant-design/icons';
import {
	DELIVERABLE_STATUSES,
	DELIVERABLE_STATUS_DISPLAY_BACKGROUND_COLORS,
	DELIVERABLE_STATUS_DISPLAY_NAMES,
	DELIVERABLE_STATUS_DISPLAY_TEXT_COLORS,
} from '../../constants/DeliverableStatuses';

const STATUS_ICONS = {
	[DELIVERABLE_STATUSES.notStarted]: MinusCircleOutlined,
	[DELIVERABLE_STATUSES.inProgress]: SyncOutlined,
	[DELIVERABLE_STATUSES.completed]: CheckCircleOutlined,
};

const DeliverableStatusDisplay = ({
	status,
	showIcon = true,
	style = {},
	textStyle = {},
	...props
}) => {
	const statusDisplayName = DELIVERABLE_STATUS_DISPLAY_NAMES[status];
	if (!statusDisplayName) {
		return null;
	}
	const statusColor = DELIVERABLE_STATUS_DISPLAY_TEXT_COLORS[status];
	const statusBackgroundColor = DELIVERABLE_STATUS_DISPLAY_BACKGROUND_COLORS[status];
	const StatusIcon = STATUS_ICONS[status];

	return (
		<span
			{...props}
			style={{
				display: 'inline-flex',
				alignItems: 'center',
				gap: 4,
				color: statusColor,
				background: statusBackgroundColor,
				padding: '0 4px',
				borderRadius: 2,
				whiteSpace: 'nowrap',
				fontSize: 12,
				fontWeight: 500,
				lineHeight: '20px',
				...style,
				...textStyle,
			}}
		>
			{showIcon && StatusIcon ? <StatusIcon style={{ fontSize: 12 }} /> : null}
			{statusDisplayName}
		</span>
	);
};

export default DeliverableStatusDisplay;
